// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2b4GW","footer":"styles_footer__37D7L"};